// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/2934

import type { DashJobsToBeDoneOption } from "./dash_jobs_to_be_done_option";

const DashJobsToBeDoneOptionValues: DashJobsToBeDoneOption[] = [
    "ai_tools",
    "search",
    "answers",
];

export function getDashJobsToBeDoneOptionFromString(s: string): DashJobsToBeDoneOption | undefined {
    return DashJobsToBeDoneOptionValues.find(e => e === s?.toLowerCase());
}
